import React, { useContext, useEffect } from 'react'
import FormDataContext from '../../../Contexts/FormData.context'
import { formActionEnum, jsonKeyMapping } from '../../../Config/Constants'
import { TemplateObject } from '../../../Models/TemplateObject'
import InputWrapper from './InputWrapper'
import InputContext from '../../../Contexts/Input.Context'

type Props = {
    formElement: TemplateObject;
    handleInputChange: (e: HTMLInputElement, startsWith: string, startsWithKey:string, inputFieldSeparator:string, prefillInputVal:string) => void;
};

const InputDateTime = ({ formElement, handleInputChange }: Props) => {
    const { state, dispatch } = useContext(FormDataContext)
    const { setConditionalInput } = useContext(InputContext)

    const { formData } = state

    useEffect(() => {
        if (formElement && formElement[jsonKeyMapping.FORM_DATE_TIME_FORMAT]) {
            const formElementData = {
                [`meta-data-${formElement[jsonKeyMapping.FORM_ID]}`]: {
                    timeFormat: formElement[jsonKeyMapping.FORM_DATE_TIME_FORMAT]
                }
            }

            dispatch({ type: formActionEnum.SET_FORM_DATA, payload: formElementData })
        }

        return () => {}
    }, [])

    /* add more fields */
    const loadFields = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value !== '' && formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS] !== undefined) {
            setConditionalInput({
                formElement: formElement[jsonKeyMapping.FORM_INPUT_RADIO_MORE_FIELDS],
                parentLabel: formElement[jsonKeyMapping.FORM_LABEL],
                value: formElement[jsonKeyMapping.FORM_VALUE]
            })
        } else {
            setConditionalInput(null)
        }
        let startsWith =""
        let isBothFieldNonEmpty = []
        let startsWithKey = ""
        let inputFieldSeparator = ""
        let prefillInputVal = formElement[jsonKeyMapping.PRE_FILL_INPUT_VAL] || ''
        if (formElement[jsonKeyMapping.STARTSWITH] !== undefined) {
            startsWith = e.target.value !== '' ? formElement[jsonKeyMapping.STARTSWITH] : ""
            inputFieldSeparator = e.target.value !== '' ? formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR] : ""
            startsWithKey = formElement[jsonKeyMapping.FORM_ID]
            isBothFieldNonEmpty = formElement[jsonKeyMapping.ISBOTHFIELDNONEMPTY] || ''
            if(isBothFieldNonEmpty !== ''){
                let frstFieldId =isBothFieldNonEmpty.split("|")[0]
                let scndFieldId =isBothFieldNonEmpty.split("|")[1]
                startsWithKey = frstFieldId
                let frstVal=''
                let scndVal=''
                if (formElement[jsonKeyMapping.FORM_ID] === frstFieldId) {
                    frstVal=e.target.value
                    scndVal= !!formData[scndFieldId] ? scndFieldId : ''
                }
                else if (formElement[jsonKeyMapping.FORM_ID] === scndFieldId) {
                    scndVal=e.target.value
                    frstVal= !!formData[frstFieldId] ? frstFieldId : ''
                }
               if(frstVal !== '' && scndVal !== ''){
                inputFieldSeparator = formElement[jsonKeyMapping.INPUT_FIELD_SEPARATOR]
               }
               else{
                inputFieldSeparator = ""
               }
               startsWith = formElement[jsonKeyMapping.STARTSWITH]
            }
        }
        let event:any = e
        handleInputChange(event,startsWith,startsWithKey,inputFieldSeparator,prefillInputVal)
    }

    return (
        <InputWrapper
            formElement={formElement}
            label={formElement[jsonKeyMapping.FORM_LABEL] || ''}
            labelsub={formElement[jsonKeyMapping.FORM_LABEL_SUB] || ''}
            subtext={formElement[jsonKeyMapping.FORM_SUBTEXT] || ''}>
            <input
                id={formElement[jsonKeyMapping.FORM_ID]}
                className={`form-control ${formElement.inputClass ? formElement.inputClass : ''
                }`}
                placeholder={formElement[jsonKeyMapping.FORM_PLACEHOLDER]}
                min={formElement.min ? formElement.min : null}
                max={formElement.max ? formElement.max : null}
                defaultValue={formElement.defaultDate}
                type="datetime-local"
                onChange={loadFields}
                value={formData[formElement[jsonKeyMapping.FORM_ID]] || ''}
            />
        </InputWrapper>
    )
}

export default InputDateTime
